import { Component, computed, effect, Inject, OnInit, signal, untracked } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngxs/store';
import { filter } from 'rxjs';
import { AppState, ChangeIsHomePageOpenAction } from './app.state';
import { LoadingIndicatorComponent } from './common/components/loading-indicator/loading-indicator.component';
import { WINDOW } from './common/services/injection-tokens';
import { FooterComponent } from './core/footer/footer.component';
import { HeaderComponent } from './core/header/header.component';

@UntilDestroy()
@Component({
  selector: 'app-root',
  imports: [
    HeaderComponent,
    RouterOutlet,
    HeaderComponent,
    LoadingIndicatorComponent,
    FooterComponent,

  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  constructor(
    private _router: Router,
    private _store: Store,
    @Inject(WINDOW) private _window: Window,
  ) {
    effect(() => {
      const isHomePage = this._isHomePageOpen();

      untracked(() => {
        this._store.dispatch(new ChangeIsHomePageOpenAction(isHomePage));
      });
    });
  }

  private _currentUrl = signal<string>('');

  private _isHomePageOpen = computed(() => this._currentUrl() === `/${ this.appState().language }`);

  protected appState = select(AppState.get);

  public ngOnInit() {
    this._router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this._currentUrl.set(this._router.url);

        this._window?.scrollTo?.(<any>{ top: 0, left: 0, behavior: 'instant' });
      });
  }
}
